import type { ReactNode } from 'react';

/** Affiche la raison d'un refus EN PREMIER (champ `detail` RFC 9457), puis les détails par champ. */
export function ErrorNotice({ title, detail, errors, requestId, action }: {
  title: string;
  detail: string;
  errors?: { field: string; message: string }[];
  requestId?: string;
  action?: ReactNode;
}) {
  return (
    <div role="alert" className="rounded-xl border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-900">
      <p className="font-semibold">{detail}</p>
      <p className="mt-1 text-red-700">{title}</p>
      {errors?.length ? (
        <ul className="mt-2 list-disc pl-5">
          {errors.map((e) => (
            <li key={e.field}>
              <span className="font-mono">{e.field}</span> : {e.message}
            </li>
          ))}
        </ul>
      ) : null}
      {requestId ? <p className="mt-2 text-xs text-red-600">Référence : {requestId}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
